import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { Tc, TcPerfilUsuarioEnum, EnumIdsTcPais, TcExpanded } from '../../../core/_infrastructure/types/common';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { SolicitudService } from '../datosbasicos/datosbasicos.service';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import {
    SolicitudViewModel,
    ParametrosNuevaSolicitudViewModel,
    PuntoInspeccionNuevaSolicitudViewModel,
    TSolicitudAdministrativoViewModel,
} from '../datosbasicos/datosbasicos.types';
import { HttpParams } from '@angular/common/http';
import {
    EnumCodigosTcTipoSolicitud,
    EnumIdsTcSubTipoSolicitud,
    EnumIdsTcTipoSolicitud,
    EnumIdsTwTcTipoTransbordo,
    EnumCodigosTwTcAcciones,
} from '../types/enum';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-tiposolicitud-list',
    templateUrl: './tiposolicitud-list.component.html',
})
export class TipoSolicitudListComponent extends ComponentBase implements OnInit {
    listTipoSolicitud: TcExpanded[];
    listPaisUe: Tc[];
    listPais: Tc[];
    listPuntoInspeccion: PuntoInspeccionNuevaSolicitudViewModel[];
    listTodosPuntoInspeccion: PuntoInspeccionNuevaSolicitudViewModel[];
    listPuntoInspeccionSinCanarias: PuntoInspeccionNuevaSolicitudViewModel[];
    listPaisTransitoDirecto: Tc[];
    listPaisTransbordo: Tc[];
    listMedioTransporte: Tc[];
    listTipoTransbordo: Tc[];
    listPCFTransbordo: PuntoInspeccionNuevaSolicitudViewModel[];

    isCollapsedTipos = false;
    isCollapsedDatosTraslado = false;
    isCollapsedDatosTransitoDirecto = false;
    isCollapsedDatosTransbordo = false;
    isCollapsedDatosFines = false;
    isCollapsedOcb = false;
    isCollapsedTipoCanarias = false;
    isCollapsedDatosCertificadoExp = false;
    isCollapsedDatosPredua = false;
    isCollapsedDatosFinTraslado = false;

    isNifFijo = false;

    esGrabador = false;
    visibleFinalizacionTraslado = false;
    esExtranjero = false;
    isCanarias = false;
    visiblePifTransbordo = false;

    CHEDPPIntroduced = '';
    CHEDPPES = false;
    codigoSolicitudPadreTraslado: string;

    mensajeSolicitudTrasladoValida = '';
    mensajeSolicitudTrasladoNOValida = '';
    mensajeSolicitudTrasladoValidadaCodigoBorrado = '';

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private solicitudService: SolicitudService,
        private navMenuService: NavMenuService,
        private confirmationService: ConfirmationService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.navMenuService.resetSolicitudData();
        this.esGrabador = this.isGrabador;

        this.visibleFinalizacionTraslado = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.FINALIZAR_TRASLADOS).Visible;

        this.loadLists();
        this.createForm();
    }

    private loadLists(): void {
        // Devuelve la lista de tipos de solicitud activos
        this.globalService.getTipoSolicitudActivos().subscribe(res => {
            this.listTipoSolicitud = res;
        });
        //Todo:agaro. Cambio a listar los de la UE 29/01/2020
        this.globalService.getAllPaises().subscribe(res => {
            this.listPais = res;
        });
        this.globalService.getPaisesUe().subscribe(res => {
            this.listPaisUe = res;
        });

        let params = new HttpParams();

        params = params.append('idpais', EnumIdsTcPais.ID_ESPANA.toString());
        params = params.append('esgrabador', this.esGrabador.toString());
        params = params.append('idusuario', this.loggedInUser!.Id.toString());

        //Todo:agaro. 12042022. Particularizamos por los pifs habilitados para importación
        this.solicitudService.getPuntoInspeccionNuevaSolicitudImportacion(params).subscribe(res => {
            this.listTodosPuntoInspeccion = res;
            //Por defecto la lista de PIFs toma TODOS
            this.listPuntoInspeccion = this.listTodosPuntoInspeccion;
        });
        //PIFs sin Canarias
        this.solicitudService.getPuntoInspeccionImportacionSinCanarias(params).subscribe(res => {
            this.listPuntoInspeccionSinCanarias = res;
        });

        //RDLF: 29/10/24 se añade España para los Tránsitos Directos (tarea 145949)
        this.globalService.getAllPaisesNoUeConSpain().subscribe(res => {
            this.listPaisTransitoDirecto = res;
        });
        this.globalService.getTipoMedioTransporte().subscribe(res => {
            this.listMedioTransporte = res;
        });
        this.globalService.getTipoTransbordo().subscribe(res => {
            this.listTipoTransbordo = res;
        });
    }

    private createForm(): void {
        this.form = this.fb.group({
            tipoSolicitud: 'N',
            esNifExtranjero: false,
            Mrn: '',
            esPredua: false,
            IdPaisTraslado: null,
            IdPuntoInspeccion: [null, Validators.required],
            FechaCartaAutorizacion: '',
            esPrevia: false,
            esReImportacion: false,
            finalizaTraslado: false,
            CHEDPP: '',
            CodigoSolicitudTraslado: '',
            EsConCF: false,
            NumCertificado: '',
            Pin: '',
            IdPaisTransitoDirecto: null,
            IdMedioTransporteTraslado: null,
            IdMedioTransporteTransitoDirecto: null,
            IdPaisTransbordo: null,
            IdMedioTransporteTransbordo: null,
            IdTipoTransbordo: null,
            IdPuntoInspeccionTransbordo: null,
        });
        this.form.controls['Mrn'].disable();
    }

    onSelectedTipoSolicitud(codigo?: string): void {
        if (codigo !== '') {
            this.form.patchValue({
                tipoSolicitud: codigo,
            });
        }
        this.resetFormValues();
        this.removeAllValidations();
        this.form.controls['esNifExtranjero'].enable();
        this.addValidator('IdPuntoInspeccion', Validators.required);
        this.form.controls['IdPuntoInspeccion'].enable();

        switch (this.form.value.tipoSolicitud) {
            case 'N': // Normal
                this.addValidatorForMrn();
                this.isNifFijo = false;
                break;
            case 'P': // Pasajeros
                this.isNifFijo = false;
                this.listPuntoInspeccion = this.listPuntoInspeccionSinCanarias;
                break;
            case 'T': // Traslado a (Punto de Control)
                this.addValidator('IdPaisTraslado', Validators.required);
                this.addValidator('IdMedioTransporteTraslado', Validators.required);

                this.form.controls['esNifExtranjero'].disable();
                this.form.patchValue({
                    esNifExtranjero: true,
                });
                this.esExtranjero = true;
                this.isNifFijo = true;
                this.listPuntoInspeccion = this.listPuntoInspeccionSinCanarias;
                break;
            case 'F': // Fines Científicos
                this.addValidator('FechaCartaAutorizacion', Validators.required);
                this.isNifFijo = false;
                break;
            case 'O': // Organismos Control Biológico
                this.addValidator('FechaCartaAutorizacion', Validators.required);
                this.isNifFijo = false;
                break;
            case 'C': // Canarias
                this.addValidatorForMrn();
                this.isNifFijo = false;
                break;
            case 'TD': // Tránsito Directo
                this.addValidator('IdPaisTransitoDirecto', Validators.required);
                this.addValidator('IdMedioTransporteTransitoDirecto', Validators.required);

                this.form.controls['esNifExtranjero'].disable();
                this.form.patchValue({
                    esNifExtranjero: true,
                });
                this.esExtranjero = true;
                this.isNifFijo = true;
                this.listPuntoInspeccion = this.listPuntoInspeccionSinCanarias;
                break;

            case 'TB': // Transbordo
                this.addValidator('IdPaisTransbordo', Validators.required);
                this.addValidator('IdMedioTransporteTransbordo', Validators.required);
                this.addValidator('IdTipoTransbordo', Validators.required);

                this.form.controls['esNifExtranjero'].disable();
                this.form.patchValue({
                    esNifExtranjero: true,
                });
                this.esExtranjero = true;
                this.isNifFijo = true;
                this.listPuntoInspeccion = this.listPuntoInspeccionSinCanarias;
                break;

            case 'PF': // Productos Fitosanitarios
                this.isNifFijo = false;
                this.form.patchValue({
                    esPredua: true,
                });
                this.form.controls['esPredua'].disable();
                this.onSelectedPreDua();
                break;

            default:
                break;
        }
    }

    private addValidatorForMrn(): void {
        this.addValidator('Mrn', Validators.required);
        this.addValidator('Mrn', Validators.minLength(18));
    }

    onSelectedNifExtranjero(): void {
        this.esExtranjero = this.form.value.esNifExtranjero;
    }

    onSelectedPreDua(): void {
        if (this.form.controls.esPredua.value === true) {
            this.addValidatorForMrn();
            this.form.controls['Mrn'].enable();
            this.form.patchValue({
                IdPuntoInspeccion: null,
            });

            if (this.form.value.EsConCF == false) {
                this.removeValidators('IdPuntoInspeccion');
                this.form.controls['IdPuntoInspeccion'].disable();
            }
            //SI ES CON CF es necesario para Guardar el PIF en la solicitud, que luego se machacará con el de PREDUA
        } else {
            this.form.patchValue({
                Mrn: '',
            });
            this.removeValidators('Mrn');
            this.form.controls['Mrn'].disable();
            this.addValidator('IdPuntoInspeccion', Validators.required);
            this.form.controls['IdPuntoInspeccion'].enable();
        }
    }

    onSelectedPrevia(): void {
        this.form.patchValue({
            esPredua: false,
            Mrn: '',
        });
        this.removeValidators('Mrn');
        this.onSelectedPreDua();
    }

    private resetFormValues() {
        this.form.patchValue({
            esNifExtranjero: false,
            Mrn: '',
            esPredua: false,
            IdPaisTraslado: null,
            IdPuntoInspeccion: null,
            FechaCartaAutorizacion: '',
            //Ocb: false,
            esPrevia: false,
            esReImportacion: false,
            finalizaTraslado: false,
            CHEDPP: '',
            CodigoSolicitudTraslado: '',
            EsConCF: false,
            NumCertificado: '',
            Pin: '',
            IdPaisTransitoDirecto: null,
            IdMedioTransporteTraslado: null,
            IdMedioTransporteTransitoDirecto: null,
            IdPaisTransbordo: null,
            IdMedioTransporteTransbordo: null,
            IdTipoTransbordo: null,
            IdPuntoInspeccionTransbordo: null,
        });
        this.form.controls['Mrn'].disable();
        this.form.controls['esPredua'].enable();
        this.esExtranjero = false;
        this.visiblePifTransbordo = false;

        //Carga los valores por defecto
        this.listPuntoInspeccion = this.listTodosPuntoInspeccion;
    }

    private removeAllValidations() {
        this.removeValidators('Mrn');
        this.removeValidators('IdPaisTraslado');
        this.removeValidators('IdMedioTransporteTraslado');
        this.removeValidators('FechaCartaAutorizacion');
        this.removeValidators('NumCertificado');
        this.removeValidators('Pin');
        this.removeValidators('IdPaisTransitoDirecto');
        this.removeValidators('IdMedioTransporteTransitoDirecto');
        this.removeValidators('IdPaisTransbordo');
        this.removeValidators('IdMedioTransporteTransbordo');
        this.removeValidators('IdTipoTransbordo');
        this.removeValidators('IdPuntoInspeccionTransbordo');
    }

    onSelectedEsConCF() {
        if (this.form.value.EsConCF == true) {
            this.addValidator('NumCertificado', Validators.required);
            this.addValidator('Pin', Validators.required);

            if (this.form.value.esPredua) {
                this.addValidator('IdPuntoInspeccion', Validators.required);
                this.form.controls['IdPuntoInspeccion'].enable();
            }
        } else {
            this.removeValidators('NumCertificado');
            this.removeValidators('Pin');
            if (this.form.value.esPredua) {
                this.removeValidators('IdPuntoInspeccion');
                this.form.controls['IdPuntoInspeccion'].disable();
            }
        }
    }

    onSelectTipoTransbordo() {
        //reseteo valores de país y PCF
        this.form.patchValue({
            IdPaisTransbordo: null,
            IdPuntoInspeccionTransbordo: null,
        });
        this.listPaisTransbordo = [];
        this.listPCFTransbordo = [];
        this.visiblePifTransbordo = false;
        this.removeValidators('IdPuntoInspeccionTransbordo');
        let idTipoTransbordo = this.form.value.IdTipoTransbordo;
        //si es a tercer pais
        if (idTipoTransbordo == EnumIdsTwTcTipoTransbordo.ID_A_TERCER_PAIS) {
            this.globalService.getAllPaisesNoUe().subscribe(res => {
                this.listPaisTransbordo = res;
            });
            this.form.patchValue({
                IdPuntoInspeccionTransbordo: null,
            });
            this.listPCFTransbordo = [];
            this.visiblePifTransbordo = false;
            this.removeValidators('IdPuntoInspeccionTransbordo');
            //si es a PCF
        } else if (idTipoTransbordo == EnumIdsTwTcTipoTransbordo.ID_A_PCF_UE) {
            this.globalService.getPaisesUe().subscribe(res => {
                this.listPaisTransbordo = res;
            });
            //Es visible el campo IdPuntoInspeccionTransbordo
            this.visiblePifTransbordo = true;
            this.addValidator('IdPuntoInspeccionTransbordo', Validators.required);
        }
    }

    onSelectPaisTransbordo() {
        if (this.form.value.IdTipoTransbordo == EnumIdsTwTcTipoTransbordo.ID_A_PCF_UE) {
            this.form.patchValue({
                IdPuntoInspeccionTransbordo: null,
            });
            this.listPCFTransbordo = [];
            let idPaisTransbordo = this.form.value.IdPaisTransbordo;
            this.solicitudService.getPcfTansbordoByPais(idPaisTransbordo).subscribe(res => {
                this.listPCFTransbordo = res;
            });
        }
    }

    onAceptar(): void {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        if (this.mensajeSolicitudTrasladoValida !== '' && this.form.value.CodigoSolicitudTraslado === '') {
            this.mensajeSolicitudTrasladoValida = '';
            this.mensajeSolicitudTrasladoNOValida = '';
            this.mensajeSolicitudTrasladoValidadaCodigoBorrado =
                'Ha validado la solicitud pero ha borrado el código de la misma. Por favor, vuelva a introducirlo y a validar la solicitud si lo que quiere es clonar los datos. Si continúa, no se clonarán los datos. ¿Está seguro?';
        }

        // Si la solicitud es de tipo Normal y finaliza un Traslado
        if (this.form.value.finalizaTraslado === true) {
            // Si no ha validado la solicitud "padre" o si la ha validado pero ha borrado el código se le preguntará
            if (
                this.mensajeSolicitudTrasladoValida === '' &&
                this.mensajeSolicitudTrasladoNOValida === '' &&
                this.mensajeSolicitudTrasladoValidadaCodigoBorrado === '' &&
                this.CHEDPPES
            ) {
                this.confirmationService.confirm({
                    message:
                        'Si no valida la solicitud en el buscador "Código de la solicitud de Traslado" no se clonarán los datos procedentes de la solicitud de tipo Traslado. ¿Está seguro?',
                    accept: () => {
                        this.writeParams();
                        this.router.navigate(['/importacion/solicitud/datosbasicos/create']);
                    },
                    reject: () => {
                        return;
                    },
                });
            } else if (this.mensajeSolicitudTrasladoValidadaCodigoBorrado !== '' && this.CHEDPPES) {
                this.confirmationService.confirm({
                    message: this.mensajeSolicitudTrasladoValidadaCodigoBorrado,
                    accept: () => {
                        this.writeParams();
                        this.router.navigate(['/importacion/solicitud/datosbasicos/create']);
                    },
                    reject: () => {
                        return;
                    },
                });
            } else if (this.mensajeSolicitudTrasladoValida !== '' && this.mensajeSolicitudTrasladoNOValida === '' && this.CHEDPPES) {
                // Si ha validado la solicitud y esta es válida (valga la redundancia) se clonarán los datos de la de tipo Traslado (la validada) a la tipo Normal (la que se va a crear)
                let idSolicitudPadre: number;
                this.solicitudService.getSolicitudTraslado(this.codigoSolicitudPadreTraslado).subscribe(res => {
                    idSolicitudPadre = res.Id;

                    if (idSolicitudPadre !== 0) {
                        let params = new HttpParams();
                        params = params.append('code', this.codigoSolicitudPadreTraslado);
                        params = params.append('idSolicitudPadre', idSolicitudPadre.toString());
                        params = params.append('CHEDPP', this.form.value.CHEDPP);
                        params = params.append('idPuntoInspeccion', this.form.value.IdPuntoInspeccion);
                        params = params.append('esExtranjero', this.form.value.esNifExtranjero);

                        this.solicitudService.cloneSolicitudTraslado(params).subscribe({
                            next: res => {
                                this.addSuccessMessage('Solicitud clonada correctamente');
                                const idSolicitud = res;
                                this.router.navigate(['/importacion/solicitud/datosbasicos/' + idSolicitud]);
                            },
                            error: error => {
                                this.catchServerError(error);
                            },
                        });
                    }
                });
            } else if (this.mensajeSolicitudTrasladoNOValida !== '' && this.CHEDPPES) {
                // Si ha validado la solicitud pero esta no es válida se le informará de que no se van a clonar los datos, y si decide continuar se pasará directamente al "create" de forma normal
                this.writeParams();
                this.router.navigate(['/importacion/solicitud/datosbasicos/create']);
            } else if (!this.CHEDPPES) {
                // Si el CHEDPP no es nacional pero es válido, se creará directamente la solicitud copiando además el CHEDPP (pdf)
                let idUsuarioSolicitante = !this.isGrabador ? this.loggedInUser!.Id : null;

                let params = new HttpParams();
                params = params.append('CHEDPP', this.form.value.CHEDPP);
                params = params.append('PIF', this.form.value.IdPuntoInspeccion);
                params = params.append('idUsuarioSolicitante', idUsuarioSolicitante!);
                params = params.append('esNifExtranjero', this.esExtranjero!);

                this.solicitudService.createSolicitudNormalFinalizaTraslado(params).subscribe({
                    next: res => {
                        this.addSuccessMessage('Solicitud creada correctamente. Se han clonado algunos datos relacionados al CHEDPP introducido.');
                        const idSolicitudNormalFinalizaTraslado = res;
                        this.router.navigate(['/importacion/solicitud/datosbasicos/' + idSolicitudNormalFinalizaTraslado]);
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            }
        } else {
            this.writeParams();

            // Si la solicitud es de tipo CANARIAS con CF se debe guardar la solicitud ya
            if (this.form.value.EsConCF == true) {
                this.onSubmit();
            } else {
                this.router.navigate(['/importacion/solicitud/datosbasicos/create']);
            }
        }
    }

    private onSubmit() {
        const solicitud = this.createSolicitudViewModel();

        this.solicitudService.createSolicitud(solicitud).subscribe({
            next: idSolicitud => {
                this.addSuccessMessage('Solicitud añadida correctamente');
                this.router.navigate(['/importacion/solicitud/datosbasicos/' + idSolicitud]);
            },
            error: error => {
                this.catchServerError(error);
            },
        });
    }

    private createSolicitudViewModel(): SolicitudViewModel {
        const solicitud = new SolicitudViewModel();

        //solicitud.Codigo = null;
        solicitud.IdTipoSolicitud = this.solicitudService.currentParamNuevaSolicitud.IdTipoSolicitud;
        solicitud.IdSubTipoSolicitud = this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud;
        solicitud.IdPuntoInspeccion = this.form.value.IdPuntoInspeccion;
        solicitud.EsExtranjero = this.esExtranjero;
        solicitud.EsPrevia = this.form.value.esPrevia;
        solicitud.EsReImportacion = this.form.value.esReImportacion != null ? this.form.value.esReImportacion : false;
        solicitud.IdFormatoSolicitud = this.isGrabador ? 2 : 1;
        solicitud.IdUsuarioSolicitante = !this.isGrabador ? this.loggedInUser!.Id : null;
        solicitud.Certificado = this.form.value.NumCertificado.trim().toUpperCase();
        solicitud.Pin = this.form.value.Pin;
        if (this.form.value.esPredua == true) {
            solicitud.TMedioTransporte.Mrn = this.form.value.Mrn;
        }

        //SOLICITUD GRABADOR
        if (this.esGrabador) {
            solicitud.TSolicitudAdministrativo = new TSolicitudAdministrativoViewModel();
            solicitud.TSolicitudAdministrativo.IdUsuarioGrabador = this.loggedInUser!.Id;
        }

        //solicitud.Id = 0;

        return solicitud;
    }

    private writeParams() {
        this.solicitudService.currentParamNuevaSolicitud = new ParametrosNuevaSolicitudViewModel();

        switch (this.form.value.tipoSolicitud) {
            case 'N': // Normal
                this.solicitudService.currentParamNuevaSolicitud.IdTipoSolicitud = EnumIdsTcTipoSolicitud.ID_NORMAL; // 1
                if (this.form.value.esPredua) {
                    this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_NORMAL_PREDUA; // 2
                } else {
                    this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_NORMAL; // 1;
                }
                break;
            case 'P': // Pasajeros
                this.solicitudService.currentParamNuevaSolicitud.IdTipoSolicitud = EnumIdsTcTipoSolicitud.ID_PASAJEROS; // 7;
                break;
            case 'T': // Traslado a (Punto de Control)
                this.solicitudService.currentParamNuevaSolicitud.IdTipoSolicitud = EnumIdsTcTipoSolicitud.ID_TRASLADO; // 2;
                if (this.form.value.esPredua) {
                    this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_TRASLADO_PREDUA; // 11
                } else {
                    this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_TRASLADO; // 10;
                }
                break;
            case 'F': // Fines Científicos
                this.solicitudService.currentParamNuevaSolicitud.IdTipoSolicitud = EnumIdsTcTipoSolicitud.ID_FINES_CIENTIFICOS; // 3;
                if (this.form.value.esPredua) {
                    this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_FINES_CIENTIFICOS_PREDUA; // 17
                } else {
                    this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_FINES_CIENTIFICOS; // 16;
                }
                break;
            case 'O': // Organismos Control Biológico
                this.solicitudService.currentParamNuevaSolicitud.IdTipoSolicitud = EnumIdsTcTipoSolicitud.ID_ORG_CONTROL_BIOLOGICO; // 4;
                break;
            case 'C': // Canarias
                this.solicitudService.currentParamNuevaSolicitud.IdTipoSolicitud = EnumIdsTcTipoSolicitud.ID_CANARIAS; // 5
                if (this.form.value.esPredua) {
                    if (this.form.value.EsConCF == true) {
                        this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_CANARIAS_PREDUA_CF; // 6;
                    } else {
                        this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_CANARIAS_PREDUA; // 5;
                    }
                } else {
                    if (this.form.value.EsConCF == true) {
                        this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_CANARIAS_CF; // 4;
                    } else {
                        this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_CANARIAS; // 3;
                    }
                }
                break;
            case 'TD': // Tránsito Directo
                this.solicitudService.currentParamNuevaSolicitud.IdTipoSolicitud = EnumIdsTcTipoSolicitud.ID_TRANSITO_DIRECTO; // 6;
                if (this.form.value.esPredua) {
                    this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_TRANSITO_DIRECTO_PREDUA; // 13
                } else {
                    this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_TRANSITO_DIRECTO; // 12;
                }
                break;
            case 'TB': // Transbordo
                this.solicitudService.currentParamNuevaSolicitud.IdTipoSolicitud = EnumIdsTcTipoSolicitud.ID_TRANSBORDO; // 8;
                if (this.form.value.esPredua) {
                    this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_TRANSBORDO_PREDUA; // 15
                } else {
                    this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_TRANSBORDO; // 14;
                }
                break;
            case 'PF': // Productos Fitosanitarios
                this.solicitudService.currentParamNuevaSolicitud.IdTipoSolicitud = EnumIdsTcTipoSolicitud.ID_PROD_FITOSANITARIOS; // 9;
                this.solicitudService.currentParamNuevaSolicitud.IdSubTipoSolicitud = EnumIdsTcSubTipoSolicitud.ID_PROD_FITO_PREDUA; // 7
                break;
        }

        this.solicitudService.currentParamNuevaSolicitud.tipoSolicitud = this.form.value.tipoSolicitud;
        this.solicitudService.currentParamNuevaSolicitud.esNifExtranjero = this.esExtranjero;
        this.solicitudService.currentParamNuevaSolicitud.Mrn = this.form.value.Mrn;
        this.solicitudService.currentParamNuevaSolicitud.esPredua = this.form.controls.esPredua.value;

        this.solicitudService.currentParamNuevaSolicitud.IdPaisTraslado = this.form.value.IdPaisTraslado;
        this.solicitudService.currentParamNuevaSolicitud.IdMedioTransporteTraslado = this.form.value.IdMedioTransporteTraslado;

        this.solicitudService.currentParamNuevaSolicitud.IdPuntoInspeccion = this.form.value.IdPuntoInspeccion;
        this.solicitudService.currentParamNuevaSolicitud.FechaCartaAutorizacion = this.form.value.FechaCartaAutorizacion;
        this.solicitudService.currentParamNuevaSolicitud.esPrevia = this.form.value.esPrevia;
        this.solicitudService.currentParamNuevaSolicitud.esReImportacion = this.form.value.esReImportacion;
        this.solicitudService.currentParamNuevaSolicitud.finalizaTraslado = this.form.value.finalizaTraslado;
        this.solicitudService.currentParamNuevaSolicitud.CHEDPP = this.form.value.CHEDPP;
        this.solicitudService.currentParamNuevaSolicitud.CodigoSolicitudTraslado = this.codigoSolicitudPadreTraslado;
        this.solicitudService.currentParamNuevaSolicitud.EsConCF = this.form.value.EsConCF;
        this.solicitudService.currentParamNuevaSolicitud.NumCertificado = this.form.value.NumCertificado;
        this.solicitudService.currentParamNuevaSolicitud.Pin = this.form.value.Pin;
        this.solicitudService.currentParamNuevaSolicitud.IdPaisTransitoDirecto = this.form.value.IdPaisTransitoDirecto;
        this.solicitudService.currentParamNuevaSolicitud.IdMedioTransporteTransitoDirecto = this.form.value.IdMedioTransporteTransitoDirecto;
        this.solicitudService.currentParamNuevaSolicitud.IdPaisTransbordo = this.form.value.IdPaisTransbordo;
        this.solicitudService.currentParamNuevaSolicitud.IdMedioTransporteTransbordo = this.form.value.IdMedioTransporteTransbordo;
        this.solicitudService.currentParamNuevaSolicitud.IdTipoTransbordo = this.form.value.IdTipoTransbordo;
        this.solicitudService.currentParamNuevaSolicitud.IdPuntoInspeccionTransbordo = this.form.value.IdPuntoInspeccionTransbordo;

        if (!this.form.controls.esPredua.value) {
            this.solicitudService.currentParamNuevaSolicitud.isPifCanarias = this.listPuntoInspeccion.find(
                x => x.Id == this.form.controls['IdPuntoInspeccion'].value,
            )!.IsCanarias;
        }

        // SET de los parametros de la nueva solicitud para guardarlos en el localStorage
        this.solicitudService.setParamsSolicitud(this.solicitudService.currentParamNuevaSolicitud);
    }

    CheckFinalizaTraslado(event: any) {
        this.removeValidators('CHEDPP');

        if (this.form.value.finalizaTraslado === false && this.form.value.CHEDPP !== '' && this.form.value.tipoSolicitud === 'N') {
            this.form.value.finalizaTraslado = true;
            this.confirmationService.confirm({
                message: 'Si desactiva el campo "Finaliza Traslado" se eliminarán los datos asociados. ¿Está seguro?',
                accept: () => {
                    this.form.patchValue({
                        finalizaTraslado: false,
                        CHEDPP: '',
                        CodigoSolicitudTraslado: '',
                    });
                    this.CHEDPPES = false;
                    this.mensajeSolicitudTrasladoValida = '';
                    this.mensajeSolicitudTrasladoNOValida = '';
                    this.removeValidators('CHEDPP');
                },
                reject: () => {
                    this.form.patchValue({
                        finalizaTraslado: true,
                    });
                    this.addValidator('CHEDPP', Validators.required);
                },
            });
        } else if (this.form.value.finalizaTraslado === true && this.form.value.CHEDPP === '') {
            this.addValidator('CHEDPP', Validators.required);
        } else if (this.form.value.tipoSolicitud !== 'N') {
            this.form.patchValue({
                finalizaTraslado: false,
                CHEDPP: '',
                CodigoSolicitudTraslado: '',
            });
            this.form.value.finalizaTraslado = false;
            this.CHEDPPES = false;
            this.mensajeSolicitudTrasladoValida = '';
            this.mensajeSolicitudTrasladoNOValida = '';
            this.removeValidators('CHEDPP');
        }
    }

    CheckCHEDPP(event: any): void {
        this.CHEDPPIntroduced = event;

        if (this.CHEDPPIntroduced !== '' || undefined) {
            if (this.CHEDPPIntroduced.toUpperCase().startsWith('CHEDPP.ES.')) {
                this.CHEDPPES = true;
            } else {
                this.CHEDPPES = false;
                this.form.patchValue({
                    CodigoSolicitudTraslado: '',
                });
            }
        }
    }

    onSearchCodigoSolicitudTraslado(code: string): void {
        this.solicitudService.getSolicitudTraslado(code).subscribe(res => {
            if (res) {
                this.mensajeSolicitudTrasladoValida =
                    'La solicitud ' + code + ' es válida para finalizar un Traslado. Se clonarán los datos en esta solicitud de tipo Normal.';
                this.mensajeSolicitudTrasladoNOValida = '';
                this.codigoSolicitudPadreTraslado = code;
            } else {
                this.mensajeSolicitudTrasladoNOValida =
                    'Solicitud no encontrada o no válida para finalizar un Traslado. No se clonarán los datos en esta solicitud de tipo Normal.';
                this.mensajeSolicitudTrasladoValida = '';
                this.codigoSolicitudPadreTraslado = '';
            }
        });
    }

    get showPreDUA(): boolean {
        return (
            this.form.value.tipoSolicitud === EnumCodigosTcTipoSolicitud.NORMAL ||
            this.form.value.tipoSolicitud === EnumCodigosTcTipoSolicitud.CANARIAS ||
            this.form.value.tipoSolicitud === EnumCodigosTcTipoSolicitud.PRODUCTOS_FITOSANITARIOS ||
            this.form.value.tipoSolicitud === EnumCodigosTcTipoSolicitud.TRASLADO ||
            this.form.value.tipoSolicitud === EnumCodigosTcTipoSolicitud.TRANSITO_DIRECTO ||
            this.form.value.tipoSolicitud === EnumCodigosTcTipoSolicitud.TRANSBORDO ||
            this.form.value.tipoSolicitud === EnumCodigosTcTipoSolicitud.FINES_CIENTIFICOS
        );
    }

    onBack() {
        this.router.navigate(['/importacion/solicitudes']);
    }
}
